import { constants } from "../constants";
import { logError } from "../errors/logger";

export const sortProducts = (products = []) => {
  if (!products || !Array.isArray(products?.items)) {
    return [];
  }

  // Create a copy of the array and sort it
  const sortedProducts = [...products.items].sort((a, b) => {
    if (a.list_sort === null && b.list_sort !== null) {
      return 1;
    }
    if (a.list_sort !== null && b.list_sort === null) {
      return -1;
    }
    return 0;
  });

  return sortedProducts;
};

export const isInvalidRouteForResolve = (pathname) => {
  if (
    [...constants.image_extensions, ...constants.file_extensions].some((str) =>
      pathname.endsWith(str),
    )
  ) {
    return true;
  }
  return constants.next_routes.some((str) => pathname.includes(str));
};

export const getFilteredItems = (vehicleInfo = {}, subChildArr = []) => {
  let filteredArr = subChildArr;
  const components = vehicleInfo?.vehicle?.components || [];
  if (components.length === 0) {
    filteredArr?.filter((childItem) => {
      const hasComponent = components?.some(
        ({ id }) => id == childItem.componentId,
      );
      return !childItem?.hasComponentId || !vehicleInfo || hasComponent;
    });
  }
  return filteredArr;
};

export { logError };
